import React, { useEffect, useState } from 'react'
import { Combobox } from '../../../../ui/combobox'
import { Input } from '../../../../ui/input'
import { Label } from '../../../../ui/label'
import { Button } from '../../../../ui/button'
import { AlertTriangle, Check, Loader2, PlusIcon, TrashIcon } from 'lucide-react'
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '../../../../ui/select'
import { useSelector } from 'react-redux'
import localforage from 'localforage'
import z from 'zod'
import { useMutation } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import axios from 'axios'

const AddUser = () => {
    const roles = useSelector((state:any)=>state.roles)
    const groups = useSelector((state:any)=>state.allGroups)

    const [email, setemail] = useState('');
    const [firstname, setfirstname] = useState('');
    const [lastname, setlastname] = useState('');
    const [language, setlanguage] = useState('N');
    const [group, setgroup] = useState('');

    const [customers, setcustomers] = useState<any[]>([]);
    const [carriers, setcarriers] = useState<any[]>([]);
    const [suppliers, setsuppliers] = useState<any[]>([]);
    
    const [role_relnr, setrole_relnr] = useState<{role:string,relnr:string}[]>([{role:'', relnr:''}]);

    useEffect(()=>{
        async function loadRelnrs () {
            setcustomers(await localforage.getItem("customers") as any[])
            setsuppliers(await localforage.getItem("suppliers") as any[])
            setcarriers(await localforage.getItem("carriers") as any[])
        }
        loadRelnrs()
    }, [])

    const { mutate, reset, isPending, isSuccess, isError } = useMutation({
        mutationFn: async () => {
            const { data } = await axios.post(`${process.env.REACT_APP_SERVER_LINK}registrationCreate`, {
                token: window.localStorage.getItem("token"),
                email: email,
                language: language,
                firstname: firstname,
                lastname: lastname,
                groupid: group,
                role: role_relnr.map(rr=>rr.role).join(';'),
                relnr: role_relnr.map(rr=>rr.relnr).join(';')
            })
            if(data.errorcode!==0){ throw new Error(data.message) }
            toast.success('Gebruiker succesvol aangemaakt', { id:'create-user' })
        },
        onError: (e:any) => {
            console.log(e.message);
            toast.error(`${e.message || 'Gebruiker aanmaken mislukt'}`, { id:'create-user'} )
            setTimeout(()=>{ reset() }, 2000)
        }
    })

    function isComplete() {
        try {
            // Define the schema for the `role_relnr` array
            const roleRelnrSchema = z.object({
                role: z.string(),
                relnr: z.string().optional()
            }).refine((item) => {
                // Ensure that `relnr` is required if `role` is not "1"
                if (item.role !== "1" && (!item.relnr || item.relnr === 'clear')) {
                    return false;
                }
                return true;
            }, {
                message: "relnr is required when role is not '1'",
                path: ["relnr"]
            });

            // Define the complete schema including `email`, `language`, and `role_relnr`
            const completeSchema = z.object({
                email: z.string().email(),
                language: z.string().min(1),
                role_relnr: z.array(roleRelnrSchema).min(1, "role_relnr must contain at least one item"),
            });

            // Validate the data
            completeSchema.parse({
                email: email,
                language: language,
                role_relnr: role_relnr
            });

            // If no error is thrown, validation is successful
            return true;
        } catch (error) {
            return false
        }
    }

    const groupsOptions = Array.isArray(groups) ? groups.map(g =>({value:g.groupid?.toString(), label:g.name})) : []
    groupsOptions.unshift({value:'', label:'Geen groep'})
    const rolesOptions = Array.isArray(roles) ? roles.map(r => ({value:r.id?.toString(), label:r.role})) : []
    const supplierOptions = Array.isArray(suppliers) ? suppliers.map(i=>({value:i.split('_')[0], label:`${i.split('_')[0]} ${i.split('_')[1]}`})) : []
    const customerOptions = Array.isArray(customers) ? customers.map(i=>({value:i.split('_')[0], label:`${i.split('_')[0]} ${i.split('_')[1]}`})) : []
    const carrierOptions = Array.isArray(carriers) ? carriers.map(i=>({value:i.split('_')[0], label:`${i.split('_')[0]} ${i.split('_')[1]}`})) : []
    
  return (
    <div className='flex flex-col gap-8 mt-8'>
        <h2 className='text-2xl font-bold text-neutral-800'>Nieuwe gebruiker aanmaken</h2>
        <div className='grid grid-cols-2 gap-4'>
            <div>
                <Label>E-mailadres<span className='ml-1 text-primary'>*</span></Label>
                <Input value={email} onChange={({currentTarget})=>{setemail(currentTarget.value)}}/>
            </div>
            <div>
                <Label>Taal<span className='ml-1 text-primary'>*</span></Label>
                <Select value={language} onValueChange={(v)=>{setlanguage(v)}}>
                    <SelectTrigger><SelectValue/></SelectTrigger>
                    <SelectContent><SelectGroup>
                        <SelectItem value="N">Nederlands</SelectItem>
                        <SelectItem value="F">Frans</SelectItem>
                        <SelectItem value="E">Engels</SelectItem>
                    </SelectGroup></SelectContent>
                </Select>
            </div>
            <div>
                <Label>Voornaam</Label>
                <Input value={firstname} onChange={({currentTarget})=>{setfirstname(currentTarget.value)}}/>
            </div>
            <div>
                <Label>Familienaam</Label>
                <Input value={lastname} onChange={({currentTarget})=>{setlastname(currentTarget.value)}}/>
            </div>
            <div>
                <Label>Groep</Label>
                <Combobox 
                    selectedValue={group} 
                    onValueChange={(v)=>{ setgroup(v.value.toString()) }} 
                    options={groupsOptions}
                    placeholder='Groep...'
                />
            </div>
            

            {role_relnr.map((rg, id)=>(
                <div className='grid grid-cols-2 gap-4 col-span-full' key={`rr-${id}`}>
                    <div className='flex items-end gap-4'>
                        {id>0&&<button onClick={()=>{setrole_relnr(p=>{let u = [...p]; u.splice(id, 1); return u;})}} className='flex items-center justify-center w-10 h-10 text-red-600 bg-red-100 rounded-full min-w-10 hover:bg-red-200'><TrashIcon className='w-4 h-4'/></button>}
                        <div className='w-full'>
                            <Label>Rol<span className='ml-1 text-primary'>*</span></Label>
                            <Combobox 
                                selectedValue={rg.role} 
                                onValueChange={(v)=>{ setrole_relnr(p=>{let u = [...p]; u[id].role = v.value.toString(); u[id].relnr = 'clear';  return u;}); }} 
                                options={rolesOptions}
                                placeholder='Rol...'
                            />
                        </div>
                    </div>
                    <div className='w-full'>
                        <Label>Relatie{rg.role!=="1"&&<span className='ml-1 text-primary'>*</span>}</Label>
                        <Combobox 
                            disabled={rg.role === '' || rg.role === '1'} selectedValue={rg.relnr} onValueChange={(v)=>{setrole_relnr(p=>{let u = [...p]; const i = u.findIndex(j => j.role === rg.role); u[i].relnr = v.value.toString(); return u;})}} 
                            options={   rg.role === '1' ? [] 
                                    : ( rg.role === '2' ? carrierOptions 
                                    : ( rg.role === '3' ? customerOptions 
                                    : ( rg.role === '4' ? supplierOptions : [])
                            ))} 
                            placeholder='Relatie...'
                        />
                    </div>
                </div>
            ))}

            <div onClick={()=>{setrole_relnr([...role_relnr, {role:'', relnr:''}])}} className='flex items-center gap-4 p-4 duration-200 border cursor-pointer bg-neutral-100 col-span-full hover:bg-neutral-200 group'>
                <div className='flex items-center justify-center w-10 h-10 bg-white border rounded-full text-neutral-600'>
                    <PlusIcon className='w-4 h-4'/>
                </div>
                <div>
                    <p className='font-semibold text-neutral-600'>Nieuwe rol</p>
                    <p className='text-sm text-neutral-400'>Nog een rol toewijzen? Klik hier</p>
                </div>
            </div>

        </div>
        <div>
            <Button onClick={()=>{mutate()}} disabled={!isComplete() || isPending || isSuccess || isError} className='gap-2'>
                {isPending && <Loader2 className='w-4 h-4 animate-spin'/>}
                {isError && <AlertTriangle className='w-4 h-4'/>}
                {isSuccess && <Check className='w-4 h-4'/>}
                Gebruiker toevoegen
            </Button>
        </div>
    </div>
  )
}

export default AddUser